module.exports = __webpack_public_path__ + "media/localization/japanese-37fd65b1.png";